import React, { useCallback, useMemo, useState } from "react";
import Settings from "../../../Components/Inputs/Settings";
import { Box, LinearProgress, Skeleton, Typography } from "@mui/material";
import { useAppSelector } from "../../../store";
import { getFullInvitationsState } from "../../../store/slices/invitations/invitations.slice";
import { isPast } from "date-fns";
import CancelSVG from "../../../assets/imgs/cancel.svg";

const DashboardSettings = () => {
	const [settingsLoading, setSettingsLoading] = useState<boolean>(false);
	const { managedInvitation, loadingManageInvitation } = useAppSelector(getFullInvitationsState);
	const handleSettingsLoadingUpdate = useCallback((status: boolean) => setSettingsLoading(status), []);
	const isInvitationClosed = useMemo(() => {
		return isPast(new Date(managedInvitation?.wedding_date || ""));
	}, [managedInvitation]);

	if (loadingManageInvitation) {
		return (
			<Box width={"100%"}>
				<Skeleton variant={"rectangular"} height={"300px"} />
			</Box>
		);
	}

	return (
		<Box style={{ position: "relative" }}>
			{settingsLoading && (
				<Box className={"linear-progress-dashboard"} position={"absolute"} top={"-20px"} zIndex={3} width={"100%"}>
					<LinearProgress />
				</Box>
			)}
			{isInvitationClosed ? (
				<Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={6} p={2}>
					<img src={CancelSVG} alt="Edit disabled" width={"300px"} />
					<Typography textAlign={"center"} variant={"h6"}>
						Invitation cannot be modified after the wedding date.
					</Typography>
				</Box>
			) : (
				<Settings handleLoadingChange={handleSettingsLoadingUpdate} />
			)}
		</Box>
	);
};

export default DashboardSettings;
